"use strict";

var _classCallCheck = require("/home/circleci/repo/app/ui-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/repo/app/ui-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/circleci/repo/app/ui-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/circleci/repo/app/ui-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/home/circleci/repo/app/ui-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/home/circleci/repo/app/ui-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AbstractTokenizer_1 = require("./AbstractTokenizer");

var CharCodes_1 = require("./enum/CharCodes");

var ParseError_1 = require("./errors/ParseError");

var Symbols_1 = require("./Symbols");

var Chars_1 = require("./utils/Chars");

var Tokenizer =
/*#__PURE__*/
function (_AbstractTokenizer_1$) {
  _inherits(Tokenizer, _AbstractTokenizer_1$);

  function Tokenizer() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Tokenizer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Tokenizer).call(this));
    _this.tokens = [];
    _this.options = Object.assign({
      useSquareTags: false
    }, options);
    var openTag = String.fromCharCode(_this.openTag);
    var closeTag = String.fromCharCode(_this.closeTag);
    _this.symbols = [{
      startToken: "".concat(openTag, "#--"),
      endToken: ["--".concat(closeTag)],
      type: Symbols_1.ENodeType.Comment,
      end: false
    }, {
      startToken: "".concat(openTag, "/#"),
      endToken: ["".concat(closeTag)],
      type: Symbols_1.ENodeType.Directive,
      end: true
    }, {
      startToken: "".concat(openTag, "#"),
      endToken: ["".concat(closeTag), "/".concat(closeTag)],
      type: Symbols_1.ENodeType.Directive,
      end: false
    }, {
      startToken: "".concat(openTag, "/@"),
      endToken: ["".concat(closeTag)],
      type: Symbols_1.ENodeType.Macro,
      end: true
    }, {
      startToken: "".concat(openTag, "@"),
      endToken: ["".concat(closeTag), "/".concat(closeTag)],
      type: Symbols_1.ENodeType.Macro,
      end: false
    }, {
      startToken: '${',
      endToken: ['}'],
      type: Symbols_1.ENodeType.Interpolation,
      end: false
    }];
    return _this;
  }

  _createClass(Tokenizer, [{
    key: "parse",
    value: function parse(template) {
      _get(_getPrototypeOf(Tokenizer.prototype), "init", this).call(this, template);

      this.tokens = [];

      while (this.index >= 0 && this.index < this.template.length) {
        this.parseTemplate();
      }

      return this.tokens;
    }
  }, {
    key: "getNextPos",
    value: function getNextPos(items) {
      var pos = -1;
      var text = '';
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;
          var n = this.template.indexOf(item, this.index);

          if (n >= 0 && (pos === -1 || n < pos)) {
            pos = n;
            text = item;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return {
        pos: pos,
        text: text
      };
    }
  }, {
    key: "parseTagName",
    value: function parseTagName() {
      var text = '';
      var ch = this.charCodeAt(this.index);

      while (this.index < this.template.length) {
        if (Chars_1.isWhitespace(ch)) {
          ++this.index;
          break;
        }

        if (ch === this.closeTag || ch === CharCodes_1.default.Slash && this.charCodeAt(this.index + 1) === this.closeTag) {
          break;
        }

        if (Chars_1.isLetter(ch) || ch === CharCodes_1.default.Period || ch === CharCodes_1.default.Underscore) {
          text += this.charAt(this.index);
          ch = this.charCodeAt(++this.index);
        } else {
          throw new ParseError_1.default("Invalid `".concat(this.charAt(this.index), "`"), {
            start: this.index,
            end: this.index
          });
        }
      }

      return text;
    }
  }, {
    key: "getToken",
    value: function getToken() {
      var symbol = null;
      var startPos = 0;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.symbols[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var item = _step2.value;
          var n = this.template.indexOf(item.startToken, this.index);

          if (n === this.index && (!symbol || n < startPos)) {
            symbol = item;
            startPos = n;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return symbol || null;
    }
  }, {
    key: "parseTemplate",
    value: function parseTemplate() {
      var text = '';
      var startPos = this.index;
      var ch;

      while (this.index < this.length) {
        ch = this.charCodeAt(this.index);

        if (ch === this.openTag || ch === CharCodes_1.default.$) {
          var token = this.getToken();

          if (token) {
            if (text.length > 0) {
              this.addToken(Symbols_1.ENodeType.Text, startPos, this.index, text);
              text = '';
            }

            var start = this.index;
            this.index += token.startToken.length;

            switch (token.type) {
              case Symbols_1.ENodeType.Comment:
                return this.parseComment(token, start);

              case Symbols_1.ENodeType.Directive:
                return this.parseDirective(token, start, Boolean(token.end));

              case Symbols_1.ENodeType.Macro:
                return this.parseMacro(token, start, Boolean(token.end));

              case Symbols_1.ENodeType.Interpolation:
                return this.parseInterpolation(token, start);
            }
          }
        }

        text += this.charAt(this.index);
        ++this.index;
      }

      return this.addToken(Symbols_1.ENodeType.Text, startPos, this.index, text);
    }
  }, {
    key: "addToken",
    value: function addToken(type, start, end, text, startTag, endTag, params) {
      var isClose = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;
      this.tokens.push({
        type: type,
        start: start,
        end: end,
        startTag: startTag,
        endTag: endTag,
        text: text,
        params: params || undefined,
        isClose: isClose
      });
    }
  }, {
    key: "parseComment",
    value: function parseComment(symbol, start) {
      var end = this.getNextPos(symbol.endToken);

      if (end.pos === -1) {
        throw new ReferenceError("Unclosed comment");
      }

      var text = this.template.substring(this.index, end.pos);
      this.index = end.pos + end.text.length;
      this.addToken(symbol.type, start, this.index, text, symbol.startToken, end.text);
    }
  }, {
    key: "parseInterpolation",
    value: function parseInterpolation(symbol, start) {
      var params = this.parseParams(symbol.endToken);
      this.addToken(symbol.type, start, this.index, '', symbol.startToken, params.endToken, params.paramText);
    }
  }, {
    key: "parseMacro",
    value: function parseMacro(symbol, start, isClose) {
      var typeString = this.parseTagName();

      if (typeString.length === 0) {
        throw new ParseError_1.default('Macro name cannot be empty', {
          start: this.index,
          end: this.index
        });
      }

      var params = this.parseParams(symbol.endToken);
      this.addToken(symbol.type, start, this.index, typeString, symbol.startToken, params.endToken, params.paramText, isClose);
    }
  }, {
    key: "parseDirective",
    value: function parseDirective(symbol, start, isClose) {
      var typeString = this.parseTagName();

      if (typeString.length === 0) {
        throw new ParseError_1.default('Directive name cannot be empty', {
          start: this.index,
          end: this.index
        });
      }

      var params = this.parseParams(symbol.endToken);
      this.addToken(symbol.type, start, this.index, typeString, symbol.startToken, params.endToken, params.paramText, isClose);
    }
  }, {
    key: "parseParams",
    value: function parseParams(endTags) {
      var paramText = '';
      var start = this.index;
      var stack = [];
      var closeCode;

      while (this.index <= this.length) {
        var ch = this.charCodeAt(this.index);

        if (closeCode !== CharCodes_1.default.DoubleQuote && closeCode !== CharCodes_1.default.SingleQuote) {
          switch (ch) {
            case CharCodes_1.default.SingleQuote:
            case CharCodes_1.default.DoubleQuote:
              if (closeCode) {
                stack.push(closeCode);
              }

              closeCode = ch;
              break;

            case CharCodes_1.default.OpenParenthesis:
              if (closeCode) {
                stack.push(closeCode);
              }

              closeCode = CharCodes_1.default.CloseParenthesis;
              break;

            case CharCodes_1.default.OpenBracket:
              if (closeCode) {
                stack.push(closeCode);
              }

              closeCode = CharCodes_1.default.CloseBracket;
              break;

            case CharCodes_1.default.CloseBracket:
            case CharCodes_1.default.CloseParenthesis:
              if (!closeCode || ch !== closeCode) {
                throw new ParseError_1.default("To many close tags ".concat(String.fromCharCode(ch)), {
                  start: start,
                  end: this.index
                });
              }

              closeCode = stack.pop();
              break;
          }
        } else {
          switch (ch) {
            case CharCodes_1.default.SingleQuote:
            case CharCodes_1.default.DoubleQuote:
              if (closeCode === ch) {
                closeCode = stack.pop();
              }

              break;
          }
        }

        if (!closeCode) {
          var nextPos = this.getNextPos(endTags);

          if (nextPos.pos !== -1 && this.index === nextPos.pos) {
            this.index += nextPos.text.length;
            return {
              paramText: paramText,
              endToken: nextPos.text
            };
          } else {
            paramText += this.charAt(this.index);
            ++this.index;
          }
        } else {
          paramText += this.charAt(this.index);
          ++this.index;
        }
      }

      if (closeCode) {
        throw new ParseError_1.default("Missing ".concat(String.fromCharCode(closeCode), " close char"), {
          start: start,
          end: this.index
        });
      }

      throw new ParseError_1.default("Unclosed directive or macro", {
        start: start,
        end: this.index
      });
    }
  }, {
    key: "openTag",
    get: function get() {
      return this.options.useSquareTags ? CharCodes_1.default.OpenBracket : CharCodes_1.default.Less;
    }
  }, {
    key: "closeTag",
    get: function get() {
      return this.options.useSquareTags ? CharCodes_1.default.CloseBracket : CharCodes_1.default.Greater;
    }
  }]);

  return Tokenizer;
}(AbstractTokenizer_1.default);

exports.Tokenizer = Tokenizer;